module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/homerun-aa6d82678bfd5c4eee078de66e55eed8.svg";